import { Global } from '@emotion/react';
import { createInstance, HackleProvider } from '@hackler/react-sdk';
import { ModalsProvider, NotificationsProvider, ThemeProvider } from '@inflearn/ds-react-next';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import Cookies from 'js-cookie';
import type { ReactNode } from 'react';

import { CDN_URL, HACKLE_BROWSER_SDK_KEY } from './appConfig';
import globals from './styles/globals';

import '@inflearn/ds-react-next/mantine-core-styles.css';
import '@inflearn/ds-react-next/mantine-notifications-styles.css';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 0,
      refetchOnReconnect: false,
      refetchOnWindowFocus: false,
      useErrorBoundary: false,
      suspense: false,
    },
  },
});

const hackleClient = createInstance(HACKLE_BROWSER_SDK_KEY, {
  exposureEventDedupIntervalMillis: 1_000,
  pollingIntervalMillis: 30_000,
});

export default function AppProvider({ children }: { children: ReactNode }) {
  const user = {
    id: Cookies.get('deviceId'),
  };

  return (
    <QueryClientProvider client={queryClient}>
      <HackleProvider hackleClient={hackleClient} user={user}>
        <ThemeProvider cdnLink={CDN_URL}>
          <NotificationsProvider />
          <ModalsProvider>
            <Global styles={[globals]} />
            {children}
          </ModalsProvider>
        </ThemeProvider>
      </HackleProvider>
    </QueryClientProvider>
  );
}
